import { Dispatch, SetStateAction, useContext, useEffect } from 'react'

import { JourneyContext } from '@/contexts/journey'
import { Trace } from '@/types/journey'
import { formatTrace } from '@/utils/traces'

interface UseTracesProps {
  traces: Trace[]
  updateTraces: (traces: Trace[]) => void
  setTraces: Dispatch<SetStateAction<Trace[]>>
  addTrace: (moduleId: string, stepId: string) => void
}

export const useTraces = (): UseTracesProps => {
  const { traces, setTraces } = useContext(JourneyContext)

  const updateTraces = (traces: Trace[]) => {
    setTraces(traces)
  }

  const addTrace = (moduleId: string, stepId: string) => {
    setTraces((prev) => {
      // If previous trace is the same as the current one, don't add it
      if (prev.length > 0 && prev[prev.length - 1]?.stepId === stepId && prev[prev.length - 1]?.moduleId === moduleId) return prev

      return [...prev, formatTrace(moduleId, stepId, prev)]
    })
  }

  return {
    traces,
    updateTraces,
    setTraces,
    addTrace
  }
}
